"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.all = all;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.getByCustId = getByCustId;

var _request = _interopRequireDefault(require("@/utils/request"));

function all(custId) {
  return (0, _request.default)({
    url: 'api/custWorkOrder/queryInfo?size=1000&custId=' + custId,
    method: 'get'
  });
}

function getByCustId(custId) {
  return (0, _request.default)({
    url: 'api/custWorkOrder?size=1000&custId=' + custId,
    method: 'get'
  });
}

function add(data) {
  return (0, _request.default)({
    url: 'api/custWorkOrder',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/custWorkOrder/',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/custWorkOrder',
    method: 'put',
    data: data
  });
}

var _default = {
  add: add,
  edit: edit,
  del: del,
  all: all,
  getByCustId: getByCustId
};
exports.default = _default;